import * as React from 'react';
import PropTypes from 'prop-types';
import TAppContent from '../../APP/TAppContent';

class RCAppSideBarAndContent extends React.Component {

    static propTypes = {
        children : PropTypes.any,
        top      : PropTypes.number,
    };

    static defaultProps = {
        children : null,
        top      : 0,
    };

    render() {

        const styles = {

            appContent : {

                top : this.props.top,

            }

        };

        return (

            <TAppContent style = {{top : styles.appContent.top}} >

                {this.props.children}

            </TAppContent>

        );
    }
}

export default RCAppSideBarAndContent;